import { useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';

import ClientsPage from '@/components/ClientsPage';
import PageHeader from '@/components/common/PageHeader';
import SideBar from '@/components/common/SideBar';
import FranchiseeSettingsPage from '@/components/FranchiseeSettingsPage';
import InspectorsPage from '@/components/InspectorsPage';
import SchedulePage from '@/components/SchedulePage';

const Page = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleToggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const { page } = useParams();

  const renderContent = () => {
    switch (page) {
      case 'clients':
        return <ClientsPage />;
      case 'inspectors':
        return <InspectorsPage />;
      case 'schedule':
        return <SchedulePage sidebarCollapsed={sidebarCollapsed} />;
      case 'settings':
        return <FranchiseeSettingsPage />;
      default:
        return <ClientsPage />;
    }
  };

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <PageHeader sidebarCollapsed={sidebarCollapsed} />
      <div className="flex flex-1">
        <SideBar handleToggleSidebar={handleToggleSidebar} sidebarCollapsed={sidebarCollapsed} />
        <main className="flex flex-1 overflow-auto bg-[#eee] p-0">
          <Routes>
            <Route path="/*" element={renderContent()} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default Page;
